import type { FaireProductEntity } from "../../entity_types/product";

export const p_4a98ge5qxv: FaireProductEntity = {
  token: "p_4a98ge5qxv",
  type: "product",
  name: "Notched Lapel Contrast Lace Slim A-line Suit Jacket",
  brandToken: "b_hrmradn4yd",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/96842c68f882eda165b94f2c8b6adeed1a45609ad2f2650ea127530fbc2d056c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8ea83a244759f833d8e9e636b2c8b6c4777b748d5641777694c8474c125ef703.png",
    "https://cdn.faire.com/fastly/49fe97c7c250ac4c2c488dc08a52231f0d41b19bfda6826d0d03acf74ad53f5c.png",
    "https://cdn.faire.com/fastly/b46ec74cd3befe3c07df3b92bff5a8e05369343273c2cd43106af38d8e7c4099.jpeg",
    "https://cdn.faire.com/fastly/5681b180972cf29b7199d31e562c257ef2e9378596ff0dfda333a55e65bb5d82.jpeg",
    "https://cdn.faire.com/fastly/da085426ec82be4dd9cf243153cd95259d6df457f870d04b2d2040a7ec550554.jpeg",
    "https://cdn.faire.com/fastly/f45f401533656313cfffcff070e98ae6beef973b899950ec651e08d71ec904c9.jpeg",
    "https://cdn.faire.com/fastly/8d5e0d240295465020e6ccda5271e3fb20d85486c0e7225404ee5e0bcf4a546d.jpeg",
    "https://cdn.faire.com/fastly/0e4852f883d709015f06e0146b859c60b1e475dea660350aded7138850af6783.jpeg",
    "https://cdn.faire.com/fastly/792b781e3457a67ee9682924e38fab7b7c966c7fcb3362c8e42bd9ea78c4b182.png",
    "https://cdn.faire.com/fastly/9525d3f26c0eb42c06d34f392a1d095e77b0455e3d88a23ded2ef3f12f71ba94.png",
    "https://cdn.faire.com/fastly/85f3835780367562d20ccb5d8de49f5e0f69a9533ddccd0ec600c673c6d54955.png",
    "https://cdn.faire.com/fastly/d2d9f8f3c9708b5796dd40e030663532f3f99264e7ccb5c42e915773fff41108.png",
  ],
  priceDollars: 43.76,
  description:
    "Notched Lapel Contrast Lace Slim A-line Suit Jacket\n95% polyester and 5% spandex, weighing 320 grams\nA unique lace-trimmed jacket that can be paired with wide-leg pants, jeans, etc.\n",
  tags: [],
  msrpDollars: 87.52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:23.824Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
